import React from 'react';

import BrowserNotSupported from 'modules/auth/components/BrowserNotSupported';
import OrganizationSelectionForm from 'modules/auth/components/OrganizationSelectionForm';

import { isBrowserSupported } from 'shared/utils/checkMobileDevice';

import AuthorizationPageLayout from '../../_layouts/AuthorizationPageLayout';
import BackgroundLayout from '../../_layouts/BackgroundLayout';

const OrganizationSelectionPage = () => {
  if (!isBrowserSupported()) {
    return (
      <BackgroundLayout>
        <BrowserNotSupported />
      </BackgroundLayout>
    );
  }

  return (
    <AuthorizationPageLayout>
      <OrganizationSelectionForm />
    </AuthorizationPageLayout>
  );

};

export default OrganizationSelectionPage;
